<template>
  <div>
    <b-row>
      <b-col lg="6" class="">
        <label class="form-label-doorder form-label-doorder-yellow"
          >Select driver</label
        >
      </b-col>
      <b-col lg="6" class="text-right justify-content-end">
        <b-form-checkbox
          v-model="notifyAllDrivers"
          class="form-check-doorder float-right mb-1"
          :indeterminate="indeterminateDriver"
          @change="toggleAllDrivers"
        >
          View all
        </b-form-checkbox>
      </b-col>
    </b-row>
    <b-card class="card-transparent-background mt-1">
      <b-card-body class="p-0">
        <b-table-simple
          class="
            table table-no-bordered table-hover
            doorderTable
            selectRowsTable
          "
          id="selectDriversTable"
          hover
          responsive
        >
          <b-thead class="d-none">
            <b-tr>
              <b-th></b-th>
              <b-th></b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="driver in drivers_list" :key="driver.id">
              <b-td class="select-checkbox">
                <input
                  type="checkbox"
                  name="selectedDrivers[]"
                  v-bind:value="driver.id"
                />
              </b-td>
              <b-td>
                <b-row>
                  <b-col md="6"
                    ><span class="select-driver-name">
                      {{ driver.name }}
                    </span></b-col
                  >
                  <b-col md="6" class="pl-0 text-right">
                    <p class="select-driver-data">{{ driver.transport }}</p>
                    <p class="select-driver-data-dot">
                      <i class="fas fa-circle"></i>
                    </p>
                    <p class="select-driver-data-km">
                      {{ driver.driverkmaway }} KM away
                    </p>
                  </b-col>
                </b-row>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "SelectDriversTableForOrder",
  components: {},
  props: ["drivers_list", "selectedDrivers","selectedDriversIndex"],
  data() {
    return {
      is_loading: false,
      notifyAllDrivers: false,
      indeterminateDriver: false,
      table: null,
    };
  },
  beforeMount() {},
  mounted() {
    // console.log(this.drivers_list);
    this.initDriversTable();
  },
  computed: {
    _circle_map_radius: {
      get() {
        return this.circle_map_radius;
      },
      set(value) {
        this.$emit("update:circle_map_radius", value);
      },
    },
  },
  methods: {
    toggleAllDrivers(checked) {
      console.log("in toggle add drivers", checked);
    },
    initDriversTable() {
      //selectDriversTable
      let temp = this;
      this.table = $("#selectDriversTable").DataTable({
        sDom: 'flti<"table_selected_rows">p',
        // sDom: 'flti<"table_selected_rows">p',
        // // buttons: [
        // //    'csv',
        // // ],
        ordering: false,
        info: true,
        destroy: true,
        responsive: true,
        scrollY: "400px",
        scrollCollapse: true,
        searching: true,
        lengthMenu: [
          [5, 10, 25, 50, 100],
          [5, 10, 25, 50, 100],
        ],
        columnDefs: [
          {
            orderable: false,
            className: "select-checkbox",
            targets: 0,
          },
        ],
        select: {
          style: "multi",
        },
        pagingType: "full_numbers",
        language: {
          paginate: {
            previous: "<i class='fas fa-angle-left'></i>",
            next: "<i class='fas fa-angle-right'></i>",
            first: "<i class='fas fa-angle-double-left'></i>",
            last: "<i class='fas fa-angle-double-right'></i>",
          },
          search: "",
          searchPlaceholder: "Search ",
        },
      });
      $("#selectDriversTable tbody")
        .off()
        .on("click", "tr td", function () {
          // console.log(table.row(this).data());
          $(this).parent().toggleClass("selected");
          // console.log($(this).hasClass("selected"));
          if ($($(this).parent().children()[0]).children().is(":checked")) {
            $($(this).parent().children()[0]).children().attr("checked", false);
          } else {
            $($(this).parent().children()[0])
              .children()
              .attr("checked", "checked");
          }

          temp.getSelectedDrivers()

          let length_selected = temp.table
            .rows()
            .nodes()
            .to$()
            .find('input[type="checkbox"]:checked').length;

          $(".table_selected_rows").html(length_selected + " row(s) selected");
        });
    },
    getSelectedDrivers() {
      let selected_index = this.table.rows(".selected")[0];
      let drivers_vals = [];
      $(this.table.rows(".selected").data()).each(function () {
        console.log($($(this)[0]).val())
        drivers_vals.push($($(this)[0]).val());
        // drivers_vals.push($(this).val());
      });
      console.log(drivers_vals);
      this.$emit("update:selectedDrivers", drivers_vals);
      this.$emit("update:selectedDriversIndex", selected_index);
      
    },
  },
};
</script>
  


// WEBPACK FOOTER //
// src/components/doorder/orders/tables_select/SelectDrivers.vue